import { inject, Inject, Injectable, Renderer2, RendererFactory2, DOCUMENT } from '@angular/core';
import { ADPResourceService } from 'digital-core';


@Injectable({
  providedIn: 'root'
})
export class OneTagService {
  private renderer: Renderer2;
  private rendererFactory = inject(RendererFactory2);
  private resourceService = inject(ADPResourceService);
  private document = inject(DOCUMENT);


  constructor() {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  initializeOneTag(): void {
    const siteKey = this.resourceService.getPortalSetting('OneTag_SiteKey').Value;

    if (siteKey && siteKey.length > 0) {
      const scriptContent = `(function(o,n,e){var l='link',s='script',c='createElement',i='insertBefore',f=o.getElementsByTagName(s)[0],p=f.parentNode,x=o[c](l),y=o[c](l),z=o[c](s);x.rel='preconnect';x.href=n;y.rel='preload';y.href=e;y.as=s;z.id='thxTag';z.src=e;p[i](x,f);p[i](y,f);p[i](z,f);})(document,'https://na5.thunderhead.com','https://na5.cdn.thunderhead.com/one/rt/js/one-tag.js?siteKey=${siteKey}');`;


      const script = this.renderer.createElement('script');
      script.text = scriptContent;
      this.renderer.appendChild(this.document.head, script);

    }
  }
}
